import Button from '@mui/material/Button';
// import { useTheme } from '@mui/material/styles';
import getTheme from '../theme/theme';

interface Props {
  href: string;
  text: string;
  disabled?: boolean;
}

const CustomButton = ({ href, text,disabled }: Props): JSX.Element => {
  const theme = getTheme();

  return (
    //This is for Header links (Features/Subscription plans/contact)
    <Button
      // component='a'
      color='primary'
      href={href}
      variant='text'
      disabled={disabled}
      sx={{
        //  color: 'black', //black color for button text
        color: disabled ? 'gray' : 'black',
        textTransform: 'uppercase',
        mx: 1.5,
        marginLeft: '15px',
        '&:active': {
          color: 'theme.palette.primary.main', //light green for button background
        },
        '&:hover': {
          color: theme.palette.text.primary,
          backgroundColor: '#9FCF3A', // Change button background color on hover to dark green
          // color: '#9FCF3A',
        },
      }}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
